<router-outlet></router-outlet>
<div class="container my-5 text-muted text-center">
  &copy; {{ year }} Vaultwarden. <br />
  {{ "versionNumber" | i18n: version }}
  <br/>
  Mon Apr 10 08:42:21 UTC 2023
  <br/>
  c3f3481528197601109a3aaeb32b7ab9c1f4a5f4
</div>
